export default function VuexEventListenerPlugin(emitter) {
    return (store) => {
        emitter.on('planning-slots-changed', (eventValues = {}) => {
            const mode = store.state.planning.mode;

            let taskIds = eventValues.taskIds || [];
            if ((!taskIds || taskIds.length === 0) && eventValues.tasks) {
                try { taskIds = Object.keys(eventValues.tasks).map((k) => parseInt(k, 10)).filter((v) => !isNaN(v)); } catch (e) {}
            }
            const personIds = eventValues.personIds || [];
            const teamIds = eventValues.teamIds || [];
            const equipmentIds = eventValues.equipmentIds || [];

            switch (mode) {
                case 'project':
                    // Always refresh visual slots for affected tasks
                    store.dispatch('planning/requestItemSlots', { itemsIds: taskIds });
                    // Necessary to refresh the task index? Not sure if this is needed
                    // If a planned filter is active, reconcile task list incrementally
                    if (store.state.planning.plannedToShow && store.state.planning.plannedToShow !== 'all') {
                        taskIds.forEach((taskId) => {
                            store.dispatch('planning/requestTaskIndex', { taskId });
                        });
                    }
                    break;
                case 'person':
                    store.dispatch('planning/requestItemSlots', { itemsIds: personIds });
                    break;
                case 'equipment':
                    store.dispatch('planning/requestItemSlots', { itemsIds: equipmentIds });
                    break;
                case 'team':
                    store.dispatch('planning/requestItemSlots', { itemsIds: teamIds });
                    break;
                case 'capacityPerson':
                    store.dispatch('planning/requestItemCapacity', { itemsIds: personIds });
                    store.dispatch('planning/requestCompanyCapacity');
                    break;
            }
        });

        emitter.on('planning-absences-changed', (eventValues) => {
            const mode = store.state.planning.mode;

            switch (mode) {
                case 'project':
                    store.dispatch('planning/requestItemAbsences', {
                        itemsIds: eventValues.itemIds,
                    });
                    break;
                case 'person':
                    store.dispatch('planning/requestItemAbsences', {
                        itemsIds: eventValues.itemIds,
                    });
                    break;
                case 'team':
                    store.dispatch('planning/requestItemAbsences', {
                        itemsIds: eventValues.itemIds,
                    });
                    break;
                case 'capacityPerson':
                    store.dispatch('planning/requestItemCapacity', {
                        itemsIds: eventValues.itemIds,
                    });
                    store.dispatch('planning/requestCompanyCapacity');
                    break;
            }
        });
    };
}
